import { createContext, useContext, useState, ReactNode } from "react";
import { Language } from "./translations";

interface LangCtx {
  lang: Language;
  setLang: (l: Language) => void;
}

const LangContext = createContext<LangCtx>({ lang: "en", setLang: () => {} });

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLang] = useState<Language>("en");
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
